export const getDeviceType = () =>
  /iphone|ipad|ipod/i.test(window.navigator.userAgent.toLowerCase())
    ? 'ios'
    : 'android'
